{
  "en": {
    "pricingPlans": {
      "error": {
        "loading": "Error loading pricing overview"
      },
      "index": {
        "headings": {
          "benefits": "Your benefits compared to free usage"
        },
        "newLayout": {
          "header": {
            "title": "Which fobizz offer is right for you?",
            "subtitle": "We support you in making your teaching more interactive and digital"
          },
          "individualSection": {
            "title": "fobizz Individual License - Just for you"
          },
          "groupSection": {
            "title": "Use fobizz together with colleagues",
            "groupLicense": {
              "title": "Group Licenses",
              "descriptionHtml": "The group license is worthwhile starting from <strong>5 people</strong>.",
              "linkText": "Group license info",
              "url": "https://fobizz.com/en/"
            },
            "groupJoin": {
              "title": "Activate Group License",
              "description": "Your institution already has a license?",
              "instruction": "Link your account here:"
            }
          },
          "trialSection": {
            "title": "Not sure what suits you yet?",
            "description": "Activate your free trial month and test the full functionality of the full plan without obligation.",
            "placeholder": "Coupon code",
            "button": "Start trial month",
            "error": "The coupon code is invalid."
          }
        },
        "paragraphs": {
          "benefitsIntro": "With the full plan, you can use all fobizz offers unlimited. With a free account, you can test fobizz without obligation, attend selected courses from the professional development catalog, and use a monthly limit for the tools. Compare all options here."
        },
        "footer": {
          "pricingInfo": "All prices per person include VAT."
        },
        "limitsTable": {
          "unlimited": "Unlimited"
        }
      },
      "links": {
        "getStarted": "Let's get started"
      }
    }
  }
}
